import { config } from "../config";
import { getCurrentUser } from "./usersService";
import { apiFetch } from "./apiService";

const loadFilesFromServer = async (uid) => {

    if( getCurrentUser() )
    {
        const apiGetVisitsFiles = config.apiData.domain+config.apiData.entities.visits.visit_files_get+`&visit_uid=${uid}`;

        return await apiFetch(apiGetVisitsFiles, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                return data.files;
            });
    }else{
        return;
    }
}

export {
    loadFilesFromServer
}
